import React from 'react';
import { Field, ErrorMessage } from 'formik';
import { useUID } from 'react-uid';
import PropTypes from 'prop-types';

const Input = ({ form, field, ...props }) => {
   let validationClass = '';
   if (form.touched[field.name] && form.errors[field.name]) {
      validationClass = 'is-invalid';
   } else if (form.touched[field.name] && form.values[field.name] !== '') {
      validationClass = 'is-valid';
   }

   return (
      <input
         {...field}
         {...props}
         className={`form-control ${validationClass} ${props.className || ''}`}
      />
   );
};

const FormikBasicField = ({
   label,
   name,
   type = 'text',
   id = undefined,
   autoComplete = false,
   disabled = false,
   maxLength = undefined,
   required = false,
   placeholder = null,
   labelVisible = true,
   fieldSrInstructions,
   fieldSrInstructionsId,
}) => {
   const uid = useUID();
   const fieldId = id || `${name}-${uid}`;
   return (
      <div className={`form-group ${required ? 'required' : ''}`}>
         <label htmlFor={fieldId} className={labelVisible ? '' : 'sr-only'}>
            {label}
            {required ? <span className="sr-only"> (required)</span> : null}
         </label>
         <Field
            name={name}
            type={type}
            id={fieldId}
            className="form-control"
            autoComplete={
               autoComplete || process.env.NODE_ENV === 'development'
                  ? 'on'
                  : 'off'
            }
            disabled={disabled}
            maxLength={maxLength}
            component={Input}
            placeholder={placeholder}
            aria-describedby={
               fieldSrInstructionsId ||
               (fieldSrInstructions ? `${fieldId}-instructions` : undefined)
            }
         />
         <ErrorMessage
            name={name}
            component="div"
            className="invalid-feedback d-block"
         />
         {fieldSrInstructions && (
            <div
               className="sr-only"
               id={fieldSrInstructionsId || `${fieldId}-instructions`}
            >
               {fieldSrInstructions}
            </div>
         )}
      </div>
   );
};

FormikBasicField.propTypes = {
   label: PropTypes.string.isRequired,
   name: PropTypes.string.isRequired,
   type: PropTypes.oneOf([
      'text',
      'email',
      'number',
      'password',
      'search',
      'tel',
      'text',
      'url',
   ]),
   id: PropTypes.string,
   autoComplete: PropTypes.bool,
   disabled: PropTypes.bool,
   maxLength: PropTypes.string,
   placeholder: PropTypes.string,
   required: PropTypes.bool,
   labelVisible: PropTypes.bool,
};

export { FormikBasicField };
